module.exports = __webpack_public_path__ + "img/btn-toExchangePrize.2c3a68ca.png";